import { render, staticRenderFns } from "./barChart.vue?vue&type=template&id=4f921633&scoped=true"
import script from "./barChart.vue?vue&type=script&lang=ts"
export * from "./barChart.vue?vue&type=script&lang=ts"
import style0 from "./barChart.vue?vue&type=style&index=0&id=4f921633&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f921633",
  null
  
)

export default component.exports